import React from 'react';
import { Box, Radio, SegmentedControl, Stack } from '@mantine/core';
import type { TypeListSort } from '@/types/list/types.list.filter';

const FilterSort: React.FC<{ sort: TypeListSort }> = ({ sort }) => {
    const current = sort.options.find((option) => option.value === sort.value);
    return (
        <Box className="bd-fp-section" role="group" aria-label="Ordinamento">
            {sort.onToggleDirection ? (
                <SegmentedControl
                    size="xs"
                    fullWidth
                    mb="xs"
                    value={sort.descending ? 'desc' : 'asc'}
                    onChange={(value) => { if ((value === 'desc') !== Boolean(sort.descending)) sort.onToggleDirection?.(); }}
                    data={[
                        { value: 'desc', label: current?.desc ?? 'Decrescente' },
                        { value: 'asc', label: current?.asc ?? 'Crescente' },
                    ]}
                    aria-label="Direzione dell'ordinamento"
                />
            ) : null}
            <Radio.Group value={sort.value} onChange={(value) => { if (value) sort.onChange(value); }} aria-label="Criterio di ordinamento">
                <Stack gap={0}>
                    {sort.options.map((option) => (
                        <Box component="label" key={option.value} className="bd-fp-option" data-checked={option.value === sort.value || undefined}>
                            <Radio size="xs" value={option.value} aria-label={option.label} />
                            <span className="bd-fp-option-label">{option.label}</span>
                        </Box>
                    ))}
                </Stack>
            </Radio.Group>
        </Box>
    );
};

export default FilterSort;
